import React, { useState, useEffect } from 'react';
import { appliquerMiseAJour } from '../serviceWorkerRegistration';

// Deux bandeaux discrets, en bas d'ecran : perte de connexion et nouvelle
// version disponible. Rien n'est affiche en fonctionnement nominal.
export default function EtatReseau({ enregistrementSW }) {
  const [horsLigne, setHorsLigne] = useState(!navigator.onLine);

  useEffect(() => {
    const enLigne = () => setHorsLigne(false);
    const perdu = () => setHorsLigne(true);
    window.addEventListener('online', enLigne);
    window.addEventListener('offline', perdu);
    return () => {
      window.removeEventListener('online', enLigne);
      window.removeEventListener('offline', perdu);
    };
  }, []);

  if (!horsLigne && !enregistrementSW) return null;

  return (
    <div style={s.zone}>
      {horsLigne && (
        <div style={{ ...s.bandeau, background: '#96281B' }}>
          <span style={s.point} />
          Vous êtes hors ligne — les données affichées peuvent dater
        </div>
      )}
      {enregistrementSW && (
        <div style={{ ...s.bandeau, background: '#0D1B2A' }}>
          <span>Nouvelle version disponible</span>
          <button type="button" onClick={() => appliquerMiseAJour(enregistrementSW)} style={s.bouton}>
            Actualiser
          </button>
        </div>
      )}
    </div>
  );
}

const s = {
  // Au-dessus de la barre de navigation mobile, encoches comprises
  zone: {
    position: 'fixed', left: 0, right: 0,
    bottom: 'calc(env(safe-area-inset-bottom, 0px) + 4px)',
    zIndex: 4000, display: 'flex', flexDirection: 'column', gap: 6,
    padding: '0 10px', pointerEvents: 'none',
  },
  bandeau: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
    color: '#fff', borderRadius: 10, padding: '10px 14px', fontSize: 12.5,
    fontWeight: 600, boxShadow: '0 4px 16px rgba(0,0,0,0.25)', pointerEvents: 'auto',
  },
  point: { width: 8, height: 8, borderRadius: '50%', background: '#F1C40F', display: 'inline-block' },
  bouton: {
    background: '#C0392B', color: '#fff', border: 'none', borderRadius: 8,
    padding: '8px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer',
    fontFamily: 'inherit', minHeight: 36,
  },
};
